<app-pronto-pago-propuesta
  *ngIf="paso === 'propuesta'"
  (continuar)="irA('verificacion')">
</app-pronto-pago-propuesta>

<app-pronto-pago-verificacion
  *ngIf="paso === 'verificacion'"
  (volver)="irA('propuesta')"
  (firmado)="irA('resultado')">
</app-pronto-pago-verificacion>

<app-pronto-pago-resultado
  *ngIf="paso === 'resultado'"
  (salir)="terminar()">
</app-pronto-pago-resultado>
